/**
 * Dashboard constants
 */

export const LARGE_BREAKPOINT_WIDTH = 1024;
